/*eslint-disable*/
import Axios from 'axios'

const API = {
  options: {
    url: '/api/sitecore/Map/datasource'
  },
  get() {
    return Axios.get(this.options.url).then((response) => {
      return response.data
    }).catch((error) => {
      console.error('API.markers()', error)
    })
  }
}

export default API
